<script lang="ts" setup>
interface Props {
  // title?: string;
}

const props = defineProps<Props>();
</script>

<template>
  <div class="col">
    <div class="card panel-card">
      <div class="card-body">
<!--        <h2 v-if="props.title" class="card-title">{{ props.title }}</h2>-->
        <slot></slot>
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.panel-card {
  height: 100%;
  border-radius: 0;
  //remove hover effect from cards in grid
  &:hover {
    //all: unset;
  }
}

</style>
